import React from 'react'
import {Link} from 'react-router-dom'
import './Footer.css'
import {ModalContainer, ModalDialog} from 'react-modal-dialog'
import {privacyPolicy} from '../../constants/constants'
import FacebookIcon from '../common/facebook.svg'
import InstagramIcon from '../common/instagram.svg'

function doScrolling(elementY, duration) { 
    var startingY = window.pageYOffset  
    var diff = elementY - startingY  
    var start

    // Bootstrap our animation - it will get called right before next frame shall be rendered.
    window.requestAnimationFrame(function step(timestamp) {
        if (!start) start = timestamp
        // Elapsed miliseconds since start of scrolling.
        var time = timestamp - start
        // Get percent of completion in range [0, 1].
        var percent = Math.min(time / duration, 1)

        window.scrollTo(0, startingY + diff * percent)

        // Proceed with animation as long as we wanted it to.
        if (time < duration) {
            window.requestAnimationFrame(step)
        }
    })
}


class DialogComponent extends React.Component {
 
    constructor(props){
        super(props)
        let { name, description } = props
        this.name = name
        this.description = description
        this.state = {isShowingModal: false}
    }

    handleClick = () => this.setState({isShowingModal: true})
    handleClose = () => this.setState({isShowingModal: false})

    render(){
        return (<span onClick={this.handleClick} className={"privacy-policy"}>
            {this.name}
            {this.state.isShowingModal && 
            <ModalContainer onClose={this.handleClose}>
                <ModalDialog onClose={this.handleClose} className="DIALOG">
                <h1>{this.name.toUpperCase()}</h1>
                <div dangerouslySetInnerHTML={{__html: this.description}}></div>
                </ModalDialog>
            </ModalContainer>}
            
        </span>)
    }
}



const onContactClick = () => {
    let main = document.getElementById("Main")
    let yPosition = main.getBoundingClientRect().top + window.scrollY;
    doScrolling(yPosition, 500)
}

const Footer = () => (
    <footer>
        <h2>¿TE QUEDA ALGUNA DUDA?</h2>
        <p>¡No dudes en contactarnos!
            <br />
            Estaremos encantados de responder cualquier consulta que tengas.</p>

        <Link className="ContactButton" to="/contacto" onClick={onContactClick}>Contactar con nosotros</Link>

        <div className="SocialMedia-List">
            <a href="https://www.facebook.com/Dental-Balmes-Igualada-109282414104534/"><img src={FacebookIcon} alt="Facebook icon"/></a>
            <a href="https://www.instagram.com/dentalbalmesigualada/"><img src={InstagramIcon} alt="Instagram icon"/></a>
        </div>

        <DialogComponent name="Aviso legal y política de privacidad" description={privacyPolicy} />
    </footer>
)

export default Footer


// WEBPACK FOOTER //
// ./src/components/footer/Footer.js